// 设置 rem 函数
export const setRem: any = function () {
  const baseSize = 32;
  // 当前页面宽度相对于 750 宽的缩放比例，可根据自己需要修改。
  const scale = document.documentElement.clientWidth / 375;
  window.SCREEN_SCALE = setRem.scale = Math.min(scale, 2);
  // 设置页面根节点字体大小
  document.documentElement.style.fontSize =
    baseSize * window.SCREEN_SCALE + "px";
};

// dom加载完成事件。返回Promise。
// !有的机型，dom没有加载完成，执行以上方法（setRem），会失效。
export const documentReady = function (chainVal?: any) {
  var d = document,
    w = window,
    loaded = /^loaded|^i|^c/.test(d.readyState),
    DOMContentLoaded = "DOMContentLoaded",
    load = "load";

  return new Promise(function (resolve) {
    if (loaded) return resolve(chainVal);

    function onReady() {
      resolve(chainVal);
      d.removeEventListener(DOMContentLoaded, onReady);
      w.removeEventListener(load, onReady);
    }

    d.addEventListener(DOMContentLoaded, onReady);
    w.addEventListener(load, onReady);
  });
};

// 初始化
setRem();
// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem();
};
